import React from "react";
import Style from '../../styles/landing/Suporte.module.css'; 
import { FaArrowLeft } from "react-icons/fa";

export default function ArtSubstituiExameMedico({ title }) {

  return (
    <div className={Style.containerArt}>

        <div className={Style.articleHeader}>
            <h2>{title}</h2>
        </div>
        <div className={Style.articleBody}>
        <p>
            Não. A avaliação corporal da LesVita <strong>não substitui</strong>{" "}
            exames médicos, consultas presenciais nem laudos emitidos por
            profissionais da saúde.
        </p>
        <p>
            Nosso objetivo é oferecer uma visão prática da sua composição corporal,
            ajudando você a acompanhar sua evolução e tomar decisões mais
            conscientes sobre treino e alimentação.
        </p>
        <p>
            Sempre que tiver dúvidas sobre sua saúde, procure um médico,
            nutricionista ou profissional habilitado.
        </p>
        </div>
    </div>
  );
}